import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../commons/Auth';
import { useTranslation } from 'react-i18next';
import { useLoading } from '../../commons/Loading';
import { useAlert } from 'react-alert';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import insurancesAPIs from '../../lib/fetch/insurancesAPIs';
import InsurancesPresentational from './InsurancesPresentational';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const InsurancesAdmin = () => {
  const [{ newToken, newIsAdmin } = {}] = useAuth();
  const [t] = useTranslation();
  const { showLoading, hideLoading } = useLoading();
  const alert = useAlert();

  const [insurances, setInsurances] = useState([]);
  const [formattedCSVInsurances, setFormattedCSVInsurances] = useState([]);
  const [total, setTotal] = useState(0);

  const [query, setQuery] = useQueryParams({
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
    insuranceStartYear: NumberParam,
    insuranceStartMonth: NumberParam,
    policy_code: withDefault(StringParam, ''),
    admin_cf: withDefault(StringParam, ''),
    customer: withDefault(StringParam, ''),
    customerType: withDefault(StringParam, ''),
    active: withDefault(StringParam, ''),
    supplier: withDefault(StringParam, ''),
  });

  const {
    limit,
    offset,
    insuranceStartYear,
    insuranceStartMonth,
    policy_code,
    admin_cf,
    customer,
    customerType,
    active,
    supplier,
  } = query;

  function onFilter(queryDiff) {
    if (
      (queryDiff.insuranceStartYear &&
        queryDiff.insuranceStartYear !== insuranceStartYear) || // first search
      (insuranceStartYear && queryDiff.insuranceStartYear === '') || // search deleted
      (queryDiff.insuranceStartMonth &&
        queryDiff.insuranceStartMonth !== insuranceStartMonth) || // first search
      (insuranceStartMonth && queryDiff.insuranceStartMonth === '') || // search deleted
      (queryDiff.policy_code && queryDiff.policy_code !== policy_code) || // first search
      (policy_code && queryDiff.policy_code === '') || // search deleted
      (queryDiff.admin_cf && queryDiff.admin_cf !== admin_cf) || // first search
      (admin_cf && queryDiff.admin_cf === '') || // search deleted
      (queryDiff.customer && queryDiff.customer !== customer) || // first search
      (customer && queryDiff.customer === '') || // search deleted
      (queryDiff.customerType && queryDiff.customerType !== customerType) || // first search
      (customerType && queryDiff.customerType === '') || // search deleted
      (queryDiff.active && queryDiff.active !== active) || // first search
      (active && queryDiff.active === '') || // search deleted
      (queryDiff.supplier && queryDiff.supplier !== supplier) || // first search
      (supplier && queryDiff.supplier === '') || // search deleted
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0; // return to first page
    }

    setQuery(queryDiff);
  }

  const fetchInsurances = async (query) => {
    showLoading();
    const { data, total: _total } = await insurancesAPIs.findAdmin({
      newToken,
      query,
    });
    hideLoading();

    setTotal(Number(_total || 0));
    setInsurances(data);
  };

  useEffect(() => {
    fetchInsurances(query);
  }, [
    limit,
    offset,
    insuranceStartYear,
    insuranceStartMonth,
    policy_code,
    admin_cf,
    customer,
    customerType,
    active,
    supplier,
  ]);

  return (
    <InsurancesPresentational
      data={insurances}
      formattedData={formattedCSVInsurances}
      query={query}
      total={total}
      onFilter={onFilter}
    />
  );
};

export default InsurancesAdmin;
